<template>
  <div>
    <div class="header" v-if="from !== 'mp'">
      <div class="imgs" @click="goback">
        <van-icon name="arrow-left" color="white" />
      </div>
      <div class="title">{{ $t("mDialogConsult.title") }}</div>
      <div class="changeLanguage" @click="changeLanguage">
        <img src="@/assets/mobile/changeLanguage.png" alt="" />
        {{ languageShortLabel }}
      </div>
    </div>
    <div class="box">
      <div
        class="name"
        :style="{ marginTop: from === 'mp' ? '2.625rem' : '5.625rem' }"
      >
        *{{ $t("mDialogConsult.tips1") }}
        <div>
          <input
            type="text"
            v-model="form.name"
            :placeholder="$t('mDialogConsult.tips1')"
            class="form-input"
          />
        </div>
      </div>
      <div class="mobile">
        *{{ $t("mDialogConsult.tips2") }}
        <div>
          <input
            type="text"
            v-model="form.mobile"
            :placeholder="$t('mDialogConsult.tips2')"
            class="form-input"
          />
        </div>
      </div>
      <div>
        <div class="section-title">*{{ $t("mDialogConsult.tips3") }}</div>
        <div v-if="isEnglish">
          <input
            type="text"
            v-model="form.locationCityArray"
            :placeholder="$t('mDialogConsult.tips4')"
            class="form-input"
            style="margin-bottom: 4vw;"
          />
        </div>
        <div v-else>
          <van-field
            v-model="form.locationCityArray"
            is-link
            readonly
            :placeholder="$t('mDialogConsult.tips4')"
            class="locationCity"
            @click="show = true"
          />
          <van-popup v-model="show" round position="bottom">
            <van-cascader
              :key="cascaderRenderKey"
              v-model="cascaderValue"
              :title="$t('mDialogConsult.tips4')"
              :placeholder="$t('mDialogConsult.tips15')"
              :options="baseCitys"
              :field-names="optionProps"
              @close="show = false"
              @finish="onFinish"
              active-color="blue"
            />
          </van-popup>
        </div>
      </div>
      <div class="msg">
        *{{ $t("mDialogConsult.tips5") }}
        <div>
          <textarea
            class="texts form-textarea"
            v-model="form.consult"
            :placeholder="$t('mDialogConsult.tips5')"
          ></textarea>
        </div>
      </div>
      <div
        class="submit"
        @click="submits"
        :style="{
          'letter-spacing': $store.state.language == 'en' ? '0' : '0.5333vw',
        }"
      >
        {{ $t("mDialogConsult.tips6") }}
      </div>
    </div>
    <change-language-popup ref="languagePopup" />
  </div>
</template>
<script>
import { submit, queryCityTreeV1 } from "../../network/gobal";
import changeLanguagePopup from "./changeLanguagePopup.vue";
import Vue from "vue";
import { Toast, Field, Popup, Cascader, Icon } from "vant";
Vue.use(Cascader);
Vue.use(Field);
Vue.use(Popup);

Vue.use(Icon);
Vue.use(Toast);
export default {
  components: {
    changeLanguagePopup,
  },
  data() {
    return {
      show: false,
      cascaderValue: "",
      cascaderRenderKey: 0,
      baseCitys: [],
      form: {
        name: "",
        mobile: "",
        consult: "",
        locationCityArray: "",
        locationCity: "",
        source: 1,
        fromPage: "",
        codeProv: "",
        codeCity: "",
      },
      optionProps: {
        text: "name",
        value: "name",
        children: "districts",
      },
      from: "",
    };
  },
  computed: {
    languageShortLabel() {
      const map = {
        "zh-Hans": "简",
        "zh-Hant": "繁",
        en: "EN",
      };
      this.setTitle();
      return map[this.getCurrentLanguage()] || "简";
    },
    isEnglish() {
      return this.getCurrentLanguage() === "en";
    },
  },
  created() {
    this.from = this.getUrlParams().from;
    let language = this.getUrlParams().language;
    if (language) {
      if (
        this.$store &&
        this.$store._mutations &&
        this.$store._mutations.CHANGE_language
      ) {
        this.$store.commit("CHANGE_language", language);
      }

      if (this.$i18n) {
        this.setTitle();
        this.$i18n.locale = language;
      }
    }
    this.$set(this.form, "mobile", this.getUrlParams().phone || "");
    this.$set(this.form, "fromPage", this.getUrlParams().fromPage || "");
    if (this.from === "mp") this.$store.commit("changeTitleShow", false);
    this.updateOptionPropsByLanguage(this.getCurrentLanguage());
    this.getAllCity();
  },
  watch: {
    "$store.state.language"(language, oldLanguage) {
      // 只在中英文类型切换时处理：
      // zh-Hans <-> zh-Hant 不处理，en -> en 不处理
      if ((language === "en") === (oldLanguage === "en")) {
        return;
      }
      this.updateOptionPropsByLanguage(language);
    },
  },
  methods: {
    setTitle() {
      let title = this.$t("app.title");
      document.title = title;
    },
    changeLanguage() {
      if (this.$refs.languagePopup) {
        this.$refs.languagePopup.open();
      }
    },
    getCurrentLanguage() {
      if (this.$store && this.$store.state && this.$store.state.language) {
        return this.$store.state.language;
      }
      return window.localStorage.getItem("language") || "zh-Hans";
    },
    updateOptionPropsByLanguage(language) {
      const useEnglish = language === "en";
      this.optionProps = {
        text: useEnglish ? "enname" : "name",
        value: useEnglish ? "enname" : "name",
        children: "districts",
      };
      this.cascaderValue = "";
      this.form.locationCityArray = "";
      this.form.codeProv = "";
      this.form.codeCity = "";
      this.show = false;
      this.cascaderRenderKey += 1;
    },
    getUrlParams(url = window.location.href) {
      const params = {};
      const searchParams = new URL(url).searchParams;

      for (const [key, value] of searchParams.entries()) {
        params[key] = value;
      }

      return params;
    },

    goback() {
      this.$router.go(-1);
    },
    submits() {
      const ruleName =
        /^(?:[\u4e00-\u9fa5]+)(?:·[\u4e00-\u9fa5]+)*$|^[a-zA-Z0-9]+\s?[.·()a-zA-Z-]*[a-zA-Z]+$/;

      if (!this.form.name) {
        Toast(this.$t("mDialogConsult.tips7"));
      } else if (!ruleName.test(this.form.name)) {
        Toast(this.$t("mDialogConsult.tips8"));
      } else if (!this.form.mobile) {
        Toast(this.$t("mDialogConsult.tips9"));
      } else if (
        !this.form.locationCityArray ||
        this.form.locationCityArray.length === 0
      ) {
        Toast(this.$t("mDialogConsult.tips11"));
      } else if (!this.form.consult) {
        Toast(this.$t("mDialogConsult.tips12"));
      } else if (this.form.consult.length > 250) {
        Toast(this.$t("mDialogConsult.tips13"));
      } else {
        this.form.locationCity = this.form.locationCityArray;
        if (this.from === "mp") this.form.source = 3;
        submit(this.form).then((res) => {
          if (res.code == 200) {
            Toast(this.$t("mDialogConsult.tips14"));
            this.form = {
              name: "",
              mobile: "",
              consult: "",
              locationCityArray: "",
              locationCity: "",
              source: 1,
              fromPage: "",
              codeProv: "",
              codeCity: "",
            };
            if (this.from !== "mp") this.$router.go(-1);
          } else {
            Toast(res.msg);
          }
        });
      }
    },

    //获取地区树
    getAllCity() {
      queryCityTreeV1().then((res) => {
        if (res.code == 200) {
          // this.baseCitys = this.getTreeData(res.data)
          this.baseCitys = this.getTreeData(res.data);
        }
      });
    },
    //递归数据进行处理
    getTreeData(data) {
      for (var i = 0; i < data.length > 0; i++) {
        if (data[i].districts == null || data[i].districts.length <= 0) {
          // districts若为空数组，则将districts设为undefined
          data[i].districts = undefined;
        } else {
          // 如果 districts 的 name 与当前对象的 name 相同，跳过该子分支(不需要这个子分支，直接设为 undefined)
          if (data[i].districts[0].name === data[i].name) {
            data[i].districts = undefined;
          } else {
            //districts若不为空数组，则继续 递归调用 本方法
            this.getTreeData(data[i].districts);
          }
        }
      }
      return data;
    },

    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      const textKey =
        this.optionProps && this.optionProps.text
          ? this.optionProps.text
          : "name";
      this.form.locationCityArray = selectedOptions
        .map((option) => option[textKey] || option.name || option.enname || "")
        .filter(Boolean)
        .join("/");
      this.form.codeProv = selectedOptions[0]?.code || "";
      this.form.codeCity = selectedOptions[1]?.code || "";
    },
  },
};
</script>
<style lang="scss" scoped>
::-webkit-input-placeholder {
  color: #cccccc;
  font-family: opposr, sans-serif;
  letter-spacing: 1px;
}
::-webkit-textarea-placeholder {
  color: #cccccc;
  font-family: opposr, sans-serif;
  letter-spacing: 1px;
  font-size: 4.0533vw;
}
.header {
  height: 14.6667vw;
  width: 100%;
  background: #1f10e0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999999;

  .imgs {
    position: absolute;
    top: 50%;
    left: 7%;
    transform: translate(-50%, -50%);
  }
  .title {
    font-size: 4.2667vw;
    font-family: opposm, sans-serif;
    font-weight: 500;
    color: #ffffff;
  }

  .changeLanguage {
    position: absolute;
    top: 50%;
    right: 4.5333vw;
    transform: translateY(-50%);
    font-weight: bold;
    font-size: 3.7333vw;
    color: #ffffff;
    font-style: normal;
    text-transform: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14.6667vw;
    height: 8vw;
    border-radius: 1.6vw;
    border: 0.2667vw solid #ffffff;

    img {
      width: 5.3333vw;
      height: 5.3333vw;
      margin-right: 0.8vw;
      display: block;
    }
  }
}
textarea {
  padding-left: 2.3333vw;
  margin-top: 2.6667vw;
  width: 100%;
  box-sizing: border-box;
  height: 26.6667vw;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  border: 0.2667vw solid #b0b5bb;
  border-radius: 1.6vw;
  -webkit-appearance: none; /*去除阴影边框*/
}
input {
  padding-left: 2.3333vw;
  width: 100%;
  box-sizing: border-box;
  height: 9.8667vw;
  border: 0.2667vw solid #b0b5bb;
  border-radius: 1.6vw;
  margin: 2.6667vw 0;
  -webkit-appearance: none; /*去除阴影边框*/
}
.box {
  padding: 0 8vw;
  font-size: 4.0533vw;
  font-family: opposm, sans-serif;
  font-weight: 400;
  color: #333333;
}
.name {
  margin-top: 24vw;
  margin-bottom: 1.3333vw;
  font-size: 4.0533vw;
}
.mobile {
  margin-bottom: 1.3333vw;
  font-size: 4.0533vw;
}
.section-title {
  font-size: 4.0533vw;
}
.submit {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 11.52vw;
  background: #1f10e0;
  box-shadow: 0 0.8vw 1.6vw 0 rgba(127, 121, 255, 0.47);
  border-radius: 1.6vw;

  font-size: 4.2667vw;
  letter-spacing: 0.5333vw;

  color: #ffffff;
  margin-top: 8.5333vw;
}
.locationCity {
  margin: 2.6667vw 0 4vw;
  padding-left: 2.3333vw;
  height: 9.8667vw;
  border: 0.2667vw solid #b0b5bb;
  border-radius: 1.6vw;
  -webkit-appearance: none; /*去除阴影边框*/
  padding-top: 2.1333vw;
  font-size: 3.6267vw;
  align-items: center;
}

::v-deep .locationCity ::placeholder {
  color: #cccccc;
  font-family: opposr, sans-serif;
  letter-spacing: 1px;
  font-size: 3.6267vw;
}

::v-deep .locationCity .van-field__control {
  font-size: 3.6267vw;
}

.msg {
  border-radius: 1.6vw;
  font-size: 4.0533vw;
}

.form-input {
  font-size: 3.6267vw;
}

.form-textarea {
  padding-top: 1.3333vw;
  font-size: 3.6267vw;
}
</style>
